
import { api_host,api_auth} from '../../common/globals/constants';

export const getDetalleDisponibilidadGlobalObjetivoCustom = (objetivo_id, node, begin, final, token, schedule) => 
fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadGlobalObjetivoCustom/?objetivoId=${objetivo_id}&horarioId=${schedule}&token=${token}&key=${api_auth}&fechaInicio=${begin}&fechaTermino=${final}&nodoId=${node}`)
.then(response => response.json())
